import React, { Component } from "react";
import * as Icon from "react-feather";
import clsx from "clsx";
import { formatDrillAmount, formatDrillDate } from "../AFSTool/shared/helpers/formatters";

import "./tools-ledger-entries.css";

class ToolsLedgerEntries extends Component {
	renderAttachments = key => {
		const { attachmentsByEntryKey, onPreviewAttachment } = this.props;
		const settled = (attachmentsByEntryKey || {})[key];
		if (!settled) return null;
		if (settled.loading) return <p className="tk-ledger-entries__attachments-note">Checking QuickBooks for attachments…</p>;
		if (settled.error) return <p className="tk-ledger-entries__attachments-note tk-ledger-entries__attachments-note--problem">{settled.error}</p>;
		if (!settled.checked) return <p className="tk-ledger-entries__attachments-note">Attachments cannot be checked for this kind of transaction yet.</p>;
		if (settled.attachments.length === 0) return <p className="tk-ledger-entries__attachments-note">No attachments on this transaction.</p>;
		return (
			<div className="tk-ledger-entries__attachments" data-test="ledger-entries-attachments">
				{settled.attachments.map(attachment => (
					<button key={attachment.id} type="button" className="tk-text-action tk-text-action--xs tk-ledger-entries__attachment" onClick={() => onPreviewAttachment({ attachment, key })}>
						<Icon.Paperclip size={12} /> {attachment.fileName}
					</button>
				))}
				{settled.previewError && <p className="tk-ledger-entries__attachments-note tk-ledger-entries__attachments-note--problem">{settled.previewError}</p>}
			</div>
		);
	};

	render() {
		const { ledger, note, onToggleAttachments, highlightedEntryKeys, columns } = this.props;
		const highlighted = highlightedEntryKeys || [];
		const shownColumns = columns || ["date", "entry", "amount"];
		const showsSplit = shownColumns.includes("split");
		const showsBalance = shownColumns.includes("balance");
		const tableClassName = clsx("tk-ledger-entries", showsSplit && "tk-ledger-entries--split", showsBalance && "tk-ledger-entries--balance");
		const openingText = formatDrillAmount(ledger.opening);
		const closingText = formatDrillAmount(ledger.closing);

		return (
			<div className={tableClassName} data-test="ledger-entries">
				{note && <p className={clsx("tk-ledger-entries__note", note.isProblem && "tk-ledger-entries__note--problem")}>{note.text}</p>}
				<div className="tk-ledger-entries__entry tk-ledger-entries__entry--head">
					<span>Date</span><span>Entry</span>
					{showsSplit && <span>Split</span>}
					<span className="tk-ledger-entries__entry-amount">Amount</span>
					{showsBalance && <span className="tk-ledger-entries__entry-amount">Balance</span>}
				</div>
				<div className="tk-ledger-entries__entry tk-ledger-entries__entry--opening">
					<span />
					<span>Opening balance</span>
					{showsSplit && <span />}
					<span className="tk-ledger-entries__entry-amount">{showsBalance ? "" : openingText}</span>
					{showsBalance && <span className="tk-ledger-entries__entry-amount">{openingText}</span>}
				</div>
				{ledger.entries.map((entry, position) => {
					const attachmentsKey = entry.transactionId ? entry.transactionType + "|" + entry.transactionId : null;
					const isHighlighted = !!attachmentsKey && highlighted.includes(attachmentsKey);
					return (
						<React.Fragment key={position}>
							<div className={clsx("tk-ledger-entries__entry", isHighlighted && "tk-ledger-entries__entry--highlighted")}>
								<span className="tk-ledger-entries__entry-date">{formatDrillDate(entry.date)}</span>
								<span className="tk-ledger-entries__entry-text" title={[entry.transactionType, entry.number, entry.name, entry.memo].filter(Boolean).join(" · ")}>
									{[entry.transactionType, entry.number].filter(Boolean).join(" ")}
									{(entry.name || entry.memo) && <span className="tk-ledger-entries__entry-memo">{entry.name || entry.memo}</span>}
									{attachmentsKey && (
										<button type="button" className="tk-text-action tk-text-action--muted tk-ledger-entries__attachments-toggle" data-test="ledger-entries-attachments-toggle" onClick={() => onToggleAttachments({ transactionType: entry.transactionType, transactionId: entry.transactionId })}>
											<Icon.Paperclip size={12} />
										</button>
									)}
								</span>
								{showsSplit && <span className="tk-ledger-entries__entry-split" title={entry.split}>{entry.split}</span>}
								<span className="tk-ledger-entries__entry-amount">{formatDrillAmount(entry.amount)}</span>
								{showsBalance && <span className="tk-ledger-entries__entry-amount">{formatDrillAmount(entry.balance)}</span>}
							</div>
							{attachmentsKey && this.renderAttachments(attachmentsKey)}
						</React.Fragment>
					);
				})}
				<div className="tk-ledger-entries__entry tk-ledger-entries__entry--total">
					<span />
					<span>Closing balance</span>
					{showsSplit && <span />}
					<span className="tk-ledger-entries__entry-amount">{showsBalance ? "" : closingText}</span>
					{showsBalance && <span className="tk-ledger-entries__entry-amount">{closingText}</span>}
				</div>
			</div>
		);
	}
}

export default ToolsLedgerEntries;
